<template>
  <div>
    <div class="column filter">
      <div v-if="!annotation">
        <div class="filter-label">
          {{ $t('terms') }}
        </div>
        <div class="filter-body">
          <ontology-tree-multiselect :ontology="ontology" :additionalNodes="additionalTermNodes"
            v-model="selectedTermsIds" />
        </div>
      </div>
      <div class="filter-label">
        {{ $t('algorithms') }}
      </div>
      <div class="filter-body">
        <cytomine-multiselect v-model="selectedAI" :options="AIs" label="ai_name" :allow-empty="false"
          :searchable="true" />
      </div>
      <div v-if="!annotation" class="filter-body">
        <cytomine-multiselect v-model="selectedType" :options="types" :allow-empty="true" :searchable="false" />
      </div>
      <div v-if="selectedAI">
        <h3>{{ selectedAI.ai_description }}</h3>
        <br>
        <a class="button is-link is-small is-fullwidth" @click="runAI()">
          {{ $t('button-launch-new-analysis') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from '@/utils/store-helpers';
import CytomineMultiselect from '@/components/form/CytomineMultiselect';
import OntologyTreeMultiselect from '@/components/ontology/OntologyTreeMultiselect';

import ViewerClient from '@/utils/viewer-client';

const WSI = "Full WSI";
const ONTOLOGY = "Full Ontology";

export default {
  name: 'list-ais',
  components: {
    CytomineMultiselect,
    OntologyTreeMultiselect
  },
  props: {
    annotation: { type: Object | null },
    image: { type: Object },
  },
  data() {
    return {
      AIs: [],
      selectedAI: null,
      selectedType: this.annotation ? '' : ONTOLOGY,
      types: [
        WSI,
        ONTOLOGY,
      ],
      noTermOption: { id: 0, name: this.$t('no-term') },
      multipleTermsOption: { id: -1, name: this.$t('multiple-terms') },
      selectedTermsIds: [],
    };
  },
  computed: {
    terms() {
      return this.$store.getters['currentProject/terms'] || [];
    },
    additionalTermNodes() {
      let additionalNodes = [this.noTermOption];
      if (this.terms.length > 1 && this.isByTerm) {
        additionalNodes.push(this.multipleTermsOption);
      }
      return additionalNodes;
    },
    ontology: get('currentProject/ontology'),
    term() {
      return this.annotation ? this.annotation.term : this.selectedTermsIds;
    },
    ids() {
      return this.annotation ? [this.annotation.id] : [];
    }
  },
  methods: {
    async runAI() {
      const wsi = this.selectedType == WSI;
      const ontology = this.selectedType == ONTOLOGY;
      ViewerClient.runAITask(this.image.id, wsi, ontology, this.selectedAI.ai_id, this.term, this.ids)
        .then(result => this.$notify({ type: 'success', text: result }))
        .catch(error => this.$notify({ type: 'error', text: error.response.data.detail }));
    },
  },
  async created() {
    this.AIs = await ViewerClient.getAIList();
    if (this.AIs.length) {
      this.selectedAI = this.AIs[0];
    }
  }
};
</script>
